import { defineMessages } from 'react-intl';

export const messages: {
	help: { defaultMessage: string; description: string; id: string };
} = defineMessages({
	help: {
		defaultMessage: 'Help',
		description: 'Accessible label and tooltip for the top navigation Help button',
		id: 'global-top-navigation.help.help',
	},
});
